import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { utils, produce, useForm } from 'passiv-libs'
import { LPA } from 'passiv-api'

import Reset from './reset'

const ResetContainer = () => {
  const history = useHistory()
  const location = useLocation()
  const [state, setState] = useState({
    loading: true,
    showForm: false,
    errorText: '',
    portal: {
      display: ''
    }
  })

  const { register, watch } = useForm({ mode: 'onChange' })

  const query = Object.fromEntries(new URLSearchParams(location.search))

  const { errors } = utils.user.passwordValidate({
    password: watch('passwordOne'),
    passwordCopy: watch('passwordTwo'),
    username: query.username
  })

  useEffect(() => {
    validateVerificationCode()
  }, [])

  const validateVerificationCode = async () => {
    try {
      const { username, verificationCode } = query
      const bool = await LPA.PUT.validateVerificationCode({ username, verificationCode })
      setState(
        produce(draft => {
          draft.showForm = bool
        })
      )
    } catch (error) {}
    setState(
      produce(draft => {
        draft.loading = false
      })
    )
  }

  const resetPassword = async () => {
    if (isEmpty(errors)) {
      const { username, verificationCode } = query
      try {
        await LPA.PUT.password({
          username,
          newPassword: watch('passwordOne'), //state.password.first,
          verificationCode
        })
        setState(
          produce(draft => {
            draft.portal.display = 'success'
          })
        )
      } catch (err) {
        setState(
          produce(draft => {
            draft.portal.display = 'password-errors'
            draft.errorText = 'Your password must be unique, be at least 8 characters long, contain at least one number and have a mixture of uppercase and lowercase letters.'
          })
        )
      }
    } else {
      setState(
        produce(draft => {
          draft.portal.display = 'password-errors'
          draft.errorText = errors.join('\n')
        })
      )
    }
  }

  const toggleModal = ({ id }) => {
    setState(
      produce(draft => {
        draft.portal.display = id
      })
    )
  }

  return (
    <Reset
      {...state}
      errors={errors}
      register={register}
      onResetPassword={resetPassword}
      onClickSuccess={() => history.push('login')}
      onBack={() => history.push('login')}
      onToggleModal={toggleModal}
    />
  )
}

export default ResetContainer
